import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

const ToggleButton = ({ 
  checked, 
  onChange, 
  label, 
  disabled = false,
  size = 'medium' // 'small', 'medium', 'large'
}) => {
  const theme = useTheme();

  // Size configurations - Smaller and more proportional
  const sizes = {
    small: {
      width: 44,
      height: 24,
      padding: 2,
      thumbSize: 20,
      translateX: 18
    },
    medium: {
      width: 48,
      height: 24,
      padding: 2,
      thumbSize: 20,
      translateX: 22
    },
    large: {
      width: 58,
      height: 32,
      padding: 3,
      thumbSize: 26,
      translateX: 26
    }
  };

  const config = sizes[size];

  const handleToggle = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        cursor: disabled ? 'default' : 'pointer',
        opacity: disabled ? 0.6 : 1,
        // Completely isolate this component from global styles
        '& *': {
          boxSizing: 'border-box'
        }
      }}
      onClick={handleToggle}
    >
      {/* Custom Toggle Switch */}
      <Box
        sx={{
          position: 'relative',
          width: config.width,
          height: config.height,
          borderRadius: config.height / 2,
          backgroundColor: checked 
            ? theme.palette.primary.main 
            : theme.palette.grey[300],
          transition: theme.transitions.create(['background-color'], {
            duration: theme.transitions.duration.shorter,
          }),
          cursor: disabled ? 'default' : 'pointer',
          opacity: disabled ? 0.6 : 1,
        }}
      >
        {/* Thumb */}
        <Box
          sx={{
            position: 'absolute',
            top: config.padding,
            left: checked 
              ? config.width - config.thumbSize - config.padding 
              : config.padding,
            width: config.thumbSize,
            height: config.thumbSize,
            backgroundColor: '#fff',
            borderRadius: '50%',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
            transition: theme.transitions.create(['left'], {
              duration: theme.transitions.duration.shorter,
            }),
          }}
        />
      </Box>

      {/* Label */}
      {label && (
        <Typography
          variant="body2"
          sx={{
            color: disabled 
              ? theme.palette.text.disabled 
              : theme.palette.text.primary,
            cursor: disabled ? 'default' : 'pointer',
            userSelect: 'none',
            fontFamily: theme.typography.fontFamily,
            fontSize: size === 'small' ? '0.875rem' : '1rem'
          }}
        >
          {label}
        </Typography>
      )}
    </Box>
  );
};

export default ToggleButton;
